import type { GetSitemapContentQueryVariables } from "@ihr-radioedit/inferno-webapi";
import { getSdk, sdkOpts } from "./sdk";
import { addSurrogateKeys } from "../lib/cache";
import { ILog } from "../lib/logging";

const sdk = getSdk(sdkOpts());
const log = ILog.logger("services/PubSub");

export const getHistoricalContent = (query: GetSitemapContentQueryVariables) =>
  sdk!.GetHistoricalContent.queryAsPromise(query).then(
    r => r.data?.pubsub?.query || { items: [], page: { nextToken: null } },
  );

const isUnboundedScan = (query: GetSitemapContentQueryVariables["query"], undated: boolean) =>
  Number.isNaN(query.pub_after) || Number.isNaN(query.pub_start) || (!undated && query.pub_after == null);

export const getSitemapContent = (
  query: GetSitemapContentQueryVariables,
  surrogateKeys?: Set<string>,
  options?: { undated?: boolean },
) => {
  if (isUnboundedScan(query.query, options?.undated ?? false)) {
    log.error(
      `Refusing sitemap query with no publish-date bounds: ${JSON.stringify(query.query)}`,
      new Error("getSitemapContent caller").stack,
    );
    return Promise.resolve([]);
  }

  return sdk!.GetSitemapContent.queryAsPromise(query).then(response => {
    if (surrogateKeys && response.data) {
      addSurrogateKeys(response, surrogateKeys);
    }
    return response.data?.pubsub?.query?.items || [];
  });
};
